module.exports = __webpack_public_path__ + "assets/img/w1.0ac8e22f.png";